import {type EnumLogoNamesWithoutVariants} from '@sproutsocial/seeds-partner-logos';

export type EnumMediaType = 'image' | 'video' | 'carousel';

export type TypePostData = {
	alt_text: string;
	link: string;
	media_type: EnumMediaType;
	media_url: string;
	post_created_epoch: number;
	post_guid: string;
};

export const getPostsData = (profile: string): Promise<Array<TypePostData>> => {
	if (!profile) {
		return Promise.resolve([]);
	}
	return fetch(`/${profile}/posts.json`, {cache: 'no-cache'}).then(response => {
		const contentType = response.headers.get('content-type');
		if (!contentType || !contentType.includes('application/json')) {
			return [];
		}
		return response.json();
	});
};

export type TypeButtonData = {
	id: string;
	page_id: number;
	button_display_text: string;
	destination_url: string;
	button_order: number;
	is_active: boolean;
};

export type TypeSocialLink = {
	id: string;
	page_id: number;
	social_platform: EnumLogoNamesWithoutVariants;
	link: string;
};

export type TypePageData = {
	page_id: number;
	profile_name: string;
	display_name: string;
	hero_image_url: string | null;
	hero_image_link: string | null;
	hero_text: string | null;
	profile_image_url: string | null;
	link_button_url: string | null;
	link_button_text: string | null;
	show_instagram_grid: boolean;
	social_links: TypeSocialLink[];
	buttons: TypeButtonData[];
};

export const getPageData = (profile: string): Promise<TypePageData> => {
	return fetch(`/${profile}/page.json`, {cache: 'no-cache'}).then(response => {
		const contentType = response.headers.get('content-type');
		if (!contentType || !contentType.includes('application/json')) {
			throw new Error('Page not found');
		}
		return response.json();
	});
};
